import * as styles from "./TreeGuides.css";

import type { JSX } from "react";

type TreeGuidesProps = {
  // Whether this is the last child in its group — the last child gets no
  // continuing line below its own elbow, so the guide doesn't dangle.
  last: boolean;
};

export function TreeGuides({ last }: TreeGuidesProps): JSX.Element {
  return (
    <>
      <span className={styles.elbow} />
      {!last && <span className={styles.line} />}
    </>
  );
}
